import request from '@/api/request.js'

// 新增
export function ProductCategoryInsert(data) {
    return request({
        url: '/api/product/productcategoryinsert',
        method: 'post',
        data: data
    })
}

// 删除
export function ProductCategoryDelete(id) {
    return request({
        url: `/api/product/productcategorydelete/${id}`,
        method: 'post',
        data: {}
    })
}

// 更新
export function ProductCategoryUpdate(id, data) {
    return request({
        url: `/api/product/productcategoryupdate/${id}`,
        method: 'post',
        data: data
    })
}

// 获取
export function ProductCategoryGetById(id) {
    return request({
        url: `/api/product/getproductcategorybyid/${id}`,
        method: 'get',
        data: {}
    })
}

// 获取列表
export function ProductCategoryGetList(params) {
    return request({
        url: '/api/product/getproductcategorylist',
        method: 'get',
        params: params
    })
}

// 获取分页列表
export function ProductCategoryGetPageList(params) {
    return request({
        url: '/api/product/getproductcategorypagelist',
        method: 'get',
        params: params
    })
}